import { gql } from '@apollo/client';

export const CREATE_WORKPLACE_MEMBER_ABSENCE = gql`
	mutation CreateWorkplaceMemberAbsence(
		$workplaceMemberIds: [UUID]!
		$start: DateTime!
		$end: DateTime!
		$description: String!
		$allowContactInAbsence: Boolean
	) {
		createWorkplaceMemberAbsence(
			input: {
				workplaceMemberIds: $workplaceMemberIds
				start: $start
				end: $end
				description: $description
				allowContactInAbsence: $allowContactInAbsence
			}
		) {
			data {
				id
			}
		}
	}
`;
